import { render } from "./EChartCard.vue?vue&type=template&id=23dc52e4&scoped=true"
import script from "./EChartCard.vue?vue&type=script&lang=js"
export * from "./EChartCard.vue?vue&type=script&lang=js"

import "./EChartCard.vue?vue&type=style&index=0&id=23dc52e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dc52e4"]])

export default __exports__